import {
    Box,
    Typography,
    AppBar,
    Toolbar,
    Button,
    Avatar,
    ButtonGroup,
    Popper,
} from "@mui/material";
import React, { useContext } from "react";
import GlobalContext from "../../contexts/globalcontext";
import { useNavigate } from "react-router-dom";
import PopperProfile from "../../components/PopperProfile";
import { green } from "@mui/material/colors";

const HeaderAppBar = () => {
    const { totalOrders } = useContext(GlobalContext);
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };
    const open = Boolean(anchorEl);
    const id = open ? "popper-avatar" : undefined;
    return (
        <Box sx={{ flexGrow: 1 }}>
            {/* <AppBar position="static"> */}
            <AppBar>
                <Toolbar>
                    <Box sx={{ flexGrow: 1 }}>
                        <Button color="inherit" onClick={() => navigate("/")}>
                            <Typography variant="h6">LOGO</Typography>
                        </Button>
                    </Box>
                    <ButtonGroup
                        variant="text"
                        color="inherit"
                        sx={{ marginRight: "2rem" }}
                    >
                        <Button onClick={() => navigate("/dashboard")}>
                            Dashboard
                        </Button>
                        <Button onClick={() => navigate("/tickers")}>
                            Tickers
                        </Button>
                        <Button onClick={() => navigate("/orders")}>
                            Orders
                        </Button>
                        <Button onClick={() => navigate("/sample")}>
                            Sample
                        </Button>
                        <Button onClick={() => navigate("/users")}>Test</Button>
                    </ButtonGroup>
                    <Button onClick={handleClick}>
                        {/* <Avatar src="/img/profile.jpg">JT</Avatar> */}
                        <Avatar sx={{ bgcolor: green[500] }}>
                            {totalOrders}
                        </Avatar>
                    </Button>
                </Toolbar>
            </AppBar>
            <Popper id={id} open={open} anchorEl={anchorEl}>
                <PopperProfile />
            </Popper>
        </Box>
    );
};

export default HeaderAppBar;
